import React from "react";
import Reveal from "../Reveal";
import Icon from "../Icon";
import { useContent } from "../../context/ContentContext";

export default function WhyChoose() {
  const { content } = useContent();
  const whyChoose = content.whyChoose || [];
  return (
    <section className="py-20 lg:py-28">
      <div className="max-w-7xl mx-auto px-5 lg:px-8">
        <Reveal className="max-w-2xl">
          <p className="text-xs uppercase tracking-[0.2em] text-[#2ED9B8] font-medium">Why choose Novocreste</p>
          <h2 className="mt-3 font-display text-[34px] lg:text-[44px] leading-[1.08] text-foreground">
            Built for speed, quality and regulatory confidence
          </h2>
        </Reveal>

        <div className="mt-12 grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {whyChoose.map((w, i) => (
            <Reveal key={w.title} delay={(i % 3) * 80}>
              <div className="group h-full bg-card rounded-2xl border border-border p-7 hover:border-[#2ED9B8]/30 transition-colors duration-300">
                <div className="h-12 w-12 rounded-xl brand-gradient flex items-center justify-center shadow-[0_10px_24px_-10px_rgba(12,97,82,0.6)]">
                  <Icon name={w.icon} className="h-6 w-6 text-white" strokeWidth={1.8} />
                </div>
                <h3 className="mt-5 font-display text-[20px] text-foreground">{w.title}</h3>
                <p className="mt-2.5 text-[14.5px] leading-relaxed text-muted-foreground">{w.desc}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
